import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  deposits: {},
  depositsAreLoaded: false,

  withdrawals: {},
  withdrawalsAreLoaded: false,

  transfers: {},
  transfersAreLoaded: false,

  paymentSystems: [],
  paymentSystemsAreLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CRM_FINANCES_DEPOSITS[REQUEST]:
      return { ...state, depositsAreLoaded: false };
    case ActionTypes.GET_CRM_FINANCES_DEPOSITS[SUCCESS]:
      return { ...state, deposits: action.data, depositsAreLoaded: true };
    case ActionTypes.GET_CRM_FINANCES_DEPOSITS[FAILURE]:
      return { ...state, error: action.error, depositsAreLoaded: false };

    case ActionTypes.GET_CRM_FINANCES_WITHDRAWALS[REQUEST]:
      return { ...state, withdrawalsAreLoaded: false };
    case ActionTypes.GET_CRM_FINANCES_WITHDRAWALS[SUCCESS]:
      return { ...state, withdrawals: action.data, withdrawalsAreLoaded: true };
    case ActionTypes.GET_CRM_FINANCES_WITHDRAWALS[FAILURE]:
      return { ...state, error: action.error, withdrawalsAreLoaded: false };

    case ActionTypes.GET_CRM_FINANCES_TRANSFERS[REQUEST]:
      return { ...state, transfersAreLoaded: false };
    case ActionTypes.GET_CRM_FINANCES_TRANSFERS[SUCCESS]:
      return { ...state, transfers: action.data, transfersAreLoaded: true };
    case ActionTypes.GET_CRM_FINANCES_TRANSFERS[FAILURE]:
      return { ...state, error: action.error, transfersAreLoaded: false };

    case ActionTypes.GET_CRM_FINANCES_PAYMENT_SYSTEMS[REQUEST]:
      return { ...state, paymentSystemsAreLoaded: false };
    case ActionTypes.GET_CRM_FINANCES_PAYMENT_SYSTEMS[SUCCESS]:
      return { ...state, paymentSystems: action.data, paymentSystemsAreLoaded: true };
    case ActionTypes.GET_CRM_FINANCES_PAYMENT_SYSTEMS[FAILURE]:
      return { ...state, error: action.error, paymentSystemsAreLoaded: false };

    default:
      return state;
  }
};

export default reducer;
